import {
  ButtonBase,
  TextField,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DevolutivasDocumentoDialog from "../../../componentes/comuns/DevolutivasDocumentoDialog";
import PapelArrastavel from "../../../componentes/comuns/PapelArrastavel";
import JanelaAuxiliar, {
  useJanelaAuxiliar,
} from "../../../componentes/comuns/JanelaAuxiliar";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import {
  coresTextosGlobais,
  tamanhosControlesGlobais,
  tamanhosPaginasAdministrativas,
} from "../../../estilos/global";
// =======================
// src/paginas/analise/processos/documentosAnalise.js
// =======================

// =======================
// src/paginas/analise/processos/documentosAnalise.js
// =======================

import { useEffect, useState, useRef } from "react";
import { keyframes } from "@emotion/react";
import {
  Box,
  Typography,
  Button,
  DialogContent,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";
import useOrdenarDocumentos from '../../../componentes/comuns/useOrdenarDocumentos';
import { api, fetchDocumentoPdf } from "@api/api";

import DownloadIcon from "@mui/icons-material/Download";
import { ajustarTamanhoFonteAnalista } from "../../../estilos/global";

const piscarDocumento = keyframes`
  0%, 100% {
    background-color: var(--sear-superficie-azul, #eef7ff);
    box-shadow: 0 0 0 0 rgba(23, 111, 178, 0.15);
  }
  50% {
    background-color: var(--sear-superficie-azul, #d2e9fc);
    box-shadow: 0 0 0 5px rgba(23, 111, 178, 0.3);
  }
`;

const getStatus = (alteracaoAtiva, aprovacao) => {
  if (alteracaoAtiva) return { text: "Correção solicitada", color: "error" };
  if (aprovacao) return { text: "Documento aprovado", color: "success" };
  return { text: "Em análise", color: "warning" };
};

const obterMensagemErro = async (response, mensagemPadrao) => {
  const dados = await response.json().catch(() => null);
  const mensagem = dados?.message;

  if (Array.isArray(mensagem)) {
    return mensagem.join(" ") || mensagemPadrao;
  }

  return typeof mensagem === "string" && mensagem.trim()
    ? mensagem
    : mensagemPadrao;
};

const DocumentViewer = ({
  documentos = [],
  processoId, versaoOrdem, origemOrdem, podeOrdenar = false,
  refreshParent,
  baixarTodos,
  baixandoTodos,
  statusDownload,
}) => {
  const [open, setOpen] = useState(false);
  const [busca, setBusca] = useState("");
  const [rascunhoOrdem, setRascunhoOrdem] = useState(documentos);
  const [ordemEditada, setOrdemEditada] = useState(false);
  const ordemEditadaRef = useRef(false);
  const [versaoBaseOrdem, setVersaoBaseOrdem] = useState(versaoOrdem);
  const [origemAtualOrdem, setOrigemAtualOrdem] = useState(origemOrdem);
  const [salvandoOrdem, setSalvandoOrdem] = useState(false);
  const salvandoOrdemRef = useRef(false);
  const tabelaOrdemRef = useRef(null);
  useEffect(() => {
    if (ordemEditadaRef.current) {
      const atuais = new Map(documentos.map((doc) => [String(doc.id), doc]));
      setRascunhoOrdem((anterior) => anterior.map((doc) => atuais.get(String(doc.id)) || doc));
    } else {
      setRascunhoOrdem(documentos); setVersaoBaseOrdem(versaoOrdem); setOrigemAtualOrdem(origemOrdem);
    }
  }, [documentos, versaoOrdem, origemOrdem]);
  const [documentosVisualizados, setDocumentosVisualizados] = useState(
    () => new Set(),
  );
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDocStatus, setSelectedDocStatus] = useState({
    alteracaoAtiva: false,
    aprovacao: false,
  });
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [openDevolver, setOpenDevolver] = useState(false);
  const [janelaAtiva, setJanelaAtiva] = useState("documento");
  const janelaDevolucao = useJanelaAuxiliar({
    aberto: openDevolver,
    titulo: "Devolução do documento — SEAR",
  });
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [erroAcao, setErroAcao] = useState("");
  const [acaoEmAndamento, setAcaoEmAndamento] = useState(null);
  const acaoEmAndamentoRef = useRef(false);

  const [documentUrl, setDocumentUrl] = useState("");
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [documentError, setDocumentError] = useState("");
  const [anexoDevolucao, setAnexoDevolucao] = useState(null);
  const [erroAnexo, setErroAnexo] = useState("");
  const anexoInputRef = useRef(null);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [erroHistorico, setErroHistorico] = useState("");
  const [documentoHistorico, setDocumentoHistorico] = useState(null);
  const [erroAnexoHistorico, setErroAnexoHistorico] = useState("");
  const historicoControllerRef = useRef(null);

  useEffect(() => () => historicoControllerRef.current?.abort(), []);

  useEffect(() => {
    if (!open || !selectedDocument?.id) {
      setDocumentUrl("");
      setDocumentError("");
      setLoadingDocument(false);
      return undefined;
    }

    const controller = new AbortController();
    let objectUrl = "";

    const carregarDocumento = async () => {
      setLoadingDocument(true);
      setDocumentError("");

      try {
        const blob = await fetchDocumentoPdf(
          api.analystDocumentoConteudo(selectedDocument.id),
          { signal: controller.signal },
        );

        objectUrl = URL.createObjectURL(blob);
        setDocumentUrl(objectUrl);
      } catch (error) {
        if (error.name !== "AbortError") {
          setDocumentError(error.message);
          setDocumentUrl("");
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoadingDocument(false);
        }
      }
    };

    carregarDocumento();

    return () => {
      controller.abort();

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [open, selectedDocument]);

  const handleOpen = (documento) => {
    if (acaoEmAndamentoRef.current) return;

    setErroAcao("");
    setSelectedDocument(documento);
    setSelectedDocStatus({
      alteracaoAtiva: documento.alteracao_ativa,
      aprovacao: documento.aprovacao,
    });
    setOpen(true);
  };

  const handleVisualizarDocumento = (documento) => {
    setDocumentosVisualizados((anteriores) =>
      new Set(anteriores).add(String(documento.id)),
    );
    handleOpen(documento);
  };

  const handleClose = () => {
    if (acaoEmAndamentoRef.current || openDevolver) return;

    setErroAcao("");
    setOpen(false);
    setSelectedDocument(null);
    setSelectedDocStatus({ alteracaoAtiva: false, aprovacao: false });
  };

  const limparAnexo = () => {
    setAnexoDevolucao(null);
    setErroAnexo("");

    if (anexoInputRef.current) {
      anexoInputRef.current.value = "";
    }
  };

  const handleSelecionarAnexo = (event) => {
    const arquivo = event.target.files?.[0];

    if (!arquivo) {
      limparAnexo();
      return;
    }

    const extensaoPermitida = /\.(pdf|doc|docx|txt)$/i.test(arquivo.name);
    const tamanhoMaximo = 5 * 1024 * 1024;

    if (!extensaoPermitida) {
      setAnexoDevolucao(null);
      setErroAnexo("Somente arquivos PDF, DOC, DOCX e TXT são permitidos.");
      event.target.value = "";
      return;
    }

    if (arquivo.size > tamanhoMaximo) {
      setAnexoDevolucao(null);
      setErroAnexo("O arquivo deve ter no máximo 5 MB.");
      event.target.value = "";
      return;
    }

    setErroAnexo("");
    setAnexoDevolucao(arquivo);
  };

  const handleOpenHistorico = async (documento) => {
    historicoControllerRef.current?.abort();
    const controller = new AbortController();
    historicoControllerRef.current = controller;
    setDocumentoHistorico(documento);
    setHistorico([]);
    setErroHistorico("");
    setErroAnexoHistorico("");
    setLoadingHistorico(true);
    setOpenHistorico(true);
    try {
      const response = await fetch(api.analystDocumentHistory(documento.id), {
        method: "GET",
        credentials: "include",
        signal: controller.signal,
      });
      if (!response.ok)
        throw new Error("Erro ao carregar o histórico do documento.");
      const data = await response.json();
      if (controller.signal.aborted) return;
      if (!Array.isArray(data))
        throw new Error(
          "Resposta inválida ao carregar o histórico do documento.",
        );
      setHistorico(data);
      setDocumentosVisualizados((anteriores) =>
        new Set(anteriores).add(String(documento.id)),
      );
    } catch (error) {
      if (!controller.signal.aborted)
        setErroHistorico("Não foi possível carregar o histórico do documento.");
    } finally {
      if (!controller.signal.aborted) setLoadingHistorico(false);
    }
  };

  const handleCloseHistorico = () => {
    historicoControllerRef.current?.abort();
    historicoControllerRef.current = null;
    setOpenHistorico(false);
    setHistorico([]);
    setLoadingHistorico(false);
    setErroHistorico("");
    setErroAnexoHistorico("");
    setDocumentoHistorico(null);
  };

  const handleBaixarAnexo = async (registro) => {
    if (!registro?.possui_anexo) {
      return;
    }

    setErroAnexoHistorico("");
    try {
      const response = await fetch(api.analystHistoryAttachment(registro.id), {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        const errorText = await response.text();

        throw new Error(errorText || "Erro ao baixar o anexo");
      }

      const arquivoBlob = await response.blob();
      const urlTemporaria = URL.createObjectURL(arquivoBlob);
      const link = document.createElement("a");

      link.href = urlTemporaria;
      link.download = registro.anexo_nome || "anexo";

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(urlTemporaria);
    } catch (error) {
      console.error("Erro ao baixar anexo:", error);

      setErroAnexoHistorico(
        "Não foi possível baixar o anexo. Tente novamente.",
      );
    }
  };

  const handleDevolver = () => {
    if (acaoEmAndamentoRef.current || openDevolver) return;

    // Abre no próprio clique, mantendo o PDF na tela principal.
    const abriuJanela = janelaDevolucao.abrir();
    setErroAcao(abriuJanela ? "" : "Não foi possível abrir a janela. Permita pop-ups para o SEAR no navegador e tente novamente.");
    setEditorState(EditorState.createEmpty());
    limparAnexo();
    setJanelaAtiva("devolucao");
    setOpenDevolver(true);
  };

  const handleCloseDevolver = () => {
    if (acaoEmAndamentoRef.current) return;

    setErroAcao("");
    limparAnexo();
    setOpenDevolver(false);
  };

  const executarAnalise = async (acao) => {
    if (acaoEmAndamentoRef.current) return;

    setErroAcao("");

    const devolvendo = acao === "devolver";

    if (!selectedDocument?.id) {
      setErroAcao("Documento inválido.");
      return;
    }

    const observacao = devolvendo
      ? editorState.getCurrentContent().getPlainText().trim()
      : "";

    if (devolvendo && !observacao) {
      setErroAcao("Por favor, informe o motivo da devolução.");
      return;
    }

    if (devolvendo && erroAnexo) {
      setErroAcao(erroAnexo);
      return;
    }

    acaoEmAndamentoRef.current = true;
    setAcaoEmAndamento(acao);

    try {
      let response;

      if (devolvendo) {
        const formData = new FormData();
        formData.append("observacao", observacao);
        formData.append("alteracao_ativa", "true");

        if (anexoDevolucao) {
          formData.append("anexo", anexoDevolucao);
        }

        response = await fetch(api.resentDoc(selectedDocument.id), {
          method: "PATCH",
          body: formData,
          credentials: "include",
        });
      } else {
        response = await fetch(api.approveDoc(selectedDocument.id), {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ aprovacao: true }),
          credentials: "include",
        });
      }

      if (!response.ok) {
        throw new Error(
          await obterMensagemErro(
            response,
            devolvendo
              ? "Erro ao devolver documento."
              : "Erro ao aprovar documento.",
          ),
        );
      }

      setAlert({
        open: true,
        message: devolvendo
          ? "Documento devolvido com sucesso"
          : "Documento aprovado com sucesso",
        severity: "success",
      });

      limparAnexo();
      setOpenDevolver(false);
      setOpen(false);
      refreshParent();
    } catch (error) {
      setErroAcao(error.message || "Não foi possível concluir a ação.");
    } finally {
      acaoEmAndamentoRef.current = false;
      setAcaoEmAndamento(null);
    }
  };

  const handleAprovar = () => executarAnalise("aprovar");
  const handleSalvarDevolucao = () => executarAnalise("devolver");

  const documentoNotificado = new URLSearchParams(window.location.search).get(
    "documento",
  );
  const normalizar = (texto = "") =>
    String(texto)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  const documentosFiltrados = (rascunhoOrdem || [])
    .map((doc) => ({
      doc,
      destacado:
        documentoNotificado !== null && String(doc.id) === documentoNotificado,
    }))
    .filter(({ doc }) =>
      normalizar(doc.nome_documento).includes(normalizar(busca)),
    )
    .sort((a, b) => ordemEditada || origemAtualOrdem ? 0 : Number(b.destacado) - Number(a.destacado));
  const ordenacao = useOrdenarDocumentos({
    ids: documentosFiltrados.map(({ doc }) => doc.id), containerRef: tabelaOrdemRef,
    desabilitado: !podeOrdenar || salvandoOrdem || Boolean(acaoEmAndamento) || Boolean(busca.trim()),
    onReordenar: (ids) => salvarOrdem(ids),
  });
  const salvarOrdem = async (ids) => {
    if (!podeOrdenar || salvandoOrdemRef.current || acaoEmAndamentoRef.current || busca.trim()) return;
    const ordemAnterior = rascunhoOrdem;
    const versaoAnterior = versaoBaseOrdem;
    const origemAnterior = origemAtualOrdem;
    const atuais = new Map(rascunhoOrdem.map((doc) => [String(doc.id), doc]));
    salvandoOrdemRef.current = true;
    ordemEditadaRef.current = true;
    setSalvandoOrdem(true); setOrdemEditada(true); setErroAcao('');
    setRascunhoOrdem(ids.map((id) => atuais.get(String(id))));
    try {
      const resposta = await fetch(api.analystDocumentOrder(processoId), {
        method: 'PATCH', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ documentos: ids, versao_ordem: versaoAnterior }),
      });
      if (!resposta.ok) {
        throw new Error(await obterMensagemErro(resposta, 'Não foi possível salvar a ordem dos documentos.'));
      }
      const dados = await resposta.json();
      setVersaoBaseOrdem(dados.versao_ordem); setOrigemAtualOrdem('analista');
    } catch (erro) {
      setRascunhoOrdem(ordemAnterior); setVersaoBaseOrdem(versaoAnterior); setOrigemAtualOrdem(origemAnterior);
      setErroAcao(erro.message || 'Não foi possível salvar a ordem dos documentos.');
    } finally {
      ordemEditadaRef.current = false; setOrdemEditada(false);
      // Aguarda a consulta atualizada antes de permitir outro movimento.
      try { await refreshParent?.(); }
      catch { setErroAcao((atual) => atual || 'Não foi possível atualizar a lista. Recarregue a página antes de reorganizar novamente.'); }
      finally { salvandoOrdemRef.current = false; setSalvandoOrdem(false); }
    }
  };
  const PapelDevolucao = janelaDevolucao.destino ? Paper : PapelArrastavel;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        border: "1px solid var(--sear-borda, #d4e5f7)",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      {alert.open && (
        <Alert
          severity={alert.severity}
          onClose={() => setAlert({ ...alert, open: false })}
          sx={{ mb: 2 }}
        >
          {alert.message}
        </Alert>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          gap: 1.5,
          px: 1.5,
          py: 1.25,
          bgcolor: "var(--sear-superficie-azul, #f5faff)",
          borderBottom: "1px solid var(--sear-borda, #d5e6f7)",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            component="h2"
            sx={{
              color: coresTextosGlobais.tituloSecao,
              fontWeight: 600,
              fontSize: tamanhosPaginasAdministrativas.tituloSecao,
            }}
          >
            Documentos do processo
          </Typography>
          <Chip
            label={documentos.length}
            size="small"
            sx={{
              color: "var(--sear-azul, #0767d8)",
              bgcolor: "var(--sear-superficie-azul, #e5f1ff)",
              fontWeight: 700,
              height: 21,
              fontSize: tamanhosControlesGlobais.contador,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            gap: 1.5,
            minWidth: 0,
            width: { xs: "100%", sm: "auto" },
            maxWidth: "100%",
          }}
        >
          <TextField
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="Pesquisar documento..."
            size="small"
            inputProps={{ "aria-label": "Pesquisar documento" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon
                    sx={{ fontSize: 18, color: "var(--sear-azul, #087cf0)" }}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              flex: { xs: "1 1 150px", sm: "0 1 220px" },
              width: { sm: 220 },
              maxWidth: "100%",
              minWidth: 0,
              "& .MuiInputBase-root": {
                height: 34,
                bgcolor: "var(--sear-superficie, #fff)",
                fontSize: tamanhosControlesGlobais.campoBusca,
                color: coresTextosGlobais.conteudoTabela,
              },
              "& fieldset": { borderColor: "var(--sear-borda, #c9def4)" },
            }}
          />
          <Button
            variant="text"
            startIcon={
              baixandoTodos ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <DownloadIcon sx={{ fontSize: 17 }} />
              )
            }
            onClick={baixarTodos}
            disabled={baixandoTodos || !documentos.length}
            aria-busy={Boolean(baixandoTodos)}
            sx={{
              minWidth: 0,
              minHeight: 34,
              flexShrink: 0,
              lineHeight: 1.2,
              textTransform: "none",
              fontSize: tamanhosControlesGlobais.botao,
              bgcolor: "transparent",
              color: "var(--sear-azul, #0875df)",
              fontWeight: 400,
              px: 0.5,
              py: 0,
              borderRadius: "3px",
              whiteSpace: "nowrap",
              boxShadow: "none",
              "& .MuiButton-startIcon": {
                ml: 0,
                mr: 0.5,
                width: 17,
                display: "inline-flex",
                justifyContent: "center",
              },
              "&:hover": {
                bgcolor: "transparent",
                textDecoration: "underline",
                boxShadow: "none",
              },
              "&.Mui-focusVisible": {
                outline: "2px solid var(--sear-borda-forte, #087cf0)",
                outlineOffset: 2,
              },
              "@media (pointer: coarse)": { minHeight: 44 },
            }}
          >
            {baixandoTodos ? "Processando..." : "Baixar todos"}
          </Button>
          <Typography
            component="span"
            role="status"
            aria-live="polite"
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "1px",
              height: "1px",
              p: 0,
              m: -1,
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            {baixandoTodos
              ? `${statusDownload}. Mantenha esta página aberta até o download começar.`
              : ""}
          </Typography>
        </Box>
      </Box>
      <Typography
        component="span" role="status" aria-live="polite"
        sx={{ position: "absolute", width: "1px", height: "1px", p: 0, m: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0 }}
      >
        {salvandoOrdem ? 'Salvando organização...' : ''}
      </Typography>
      {erroAcao && <Alert severity="error" sx={{ mx: 1.5, mb: 1 }}>{erroAcao}</Alert>}
      <TableContainer
        ref={tabelaOrdemRef}
        data-rolagem-conteudo=""
        sx={{
          flex: { md: "1 1 0" },
          minHeight: 0,
          maxHeight: { xs: 420, md: "none" },
          overflowY: "auto",
          overflowX: { xs: "visible", sm: "auto" },
        }}
      >
        <Table
          size="small"
          stickyHeader
          aria-label="Documentos para análise"
          sx={{
            tableLayout: "fixed",
            minWidth: { xs: 0, sm: 640 },
            display: { xs: "block", sm: "table" },
            "& thead": { display: { xs: "none", sm: "table-header-group" } },
            "& colgroup": { display: { xs: "none", sm: "table-column-group" } },
            "& col:nth-of-type(1)": { width: { sm: "41%", lg: "auto" } },
            "& col:nth-of-type(2)": { width: { sm: "25%", lg: 180 } },
            "& col:nth-of-type(3)": { width: { sm: "22%", lg: 180 } },
            "& col:nth-of-type(4)": { width: { sm: "12%", lg: 120 } },
            "& tbody": { display: { xs: "block", sm: "table-row-group" } },
            "& tbody > tr": {
              display: { xs: "grid", sm: "table-row" },
              gridTemplateColumns: "repeat(3,minmax(0,1fr))",
              gap: { xs: "10px 6px", sm: 0 },
              p: { xs: 1.5, sm: 0 },
              borderBottom: {
                xs: "1px solid var(--sear-borda, #e2edf9)",
                sm: 0,
              },
            },
            "& th": {
              bgcolor: "var(--sear-superficie-azul, #f0f7ff)",
              color: coresTextosGlobais.cabecalhoTabela,
              fontWeight: 600,
              fontSize: tamanhosPaginasAdministrativas.cabecalhoTabela,
              py: 0.7,
              px: 1.4,
              textAlign: "center",
              borderBottom: "1px solid var(--sear-borda, #d5e6f7)",
            },
            "& th:first-of-type": { textAlign: "left" },
            "& th + th": { borderLeft: "1px solid var(--sear-borda, #e3edf8)" },
            "& td": {
              display: { xs: "block", sm: "table-cell" },
              fontSize: tamanhosPaginasAdministrativas.conteudoTabela,
              color: coresTextosGlobais.conteudoTabela,
              py: { xs: 0, sm: 0.5 },
              px: { xs: 0, sm: 1.4 },
              textAlign: "center",
              verticalAlign: "middle",
              borderBottomWidth: { xs: 0, sm: 1 },
              borderColor: "var(--sear-borda, #e2edf9)",
              overflowWrap: "anywhere",
              fontWeight: 400,
              minWidth: 0,
            },
            "& td:first-of-type": { textAlign: "left", gridColumn: "1 / -1" },
            "& td:nth-of-type(2)": {
              textAlign: { xs: "left", sm: "center" },
              gridColumn: "1 / -1",
            },
            "& td:nth-of-type(3)": {
              gridColumn: "1 / span 2",
              textAlign: { xs: "left", sm: "center" },
            },
            "& td:nth-of-type(3)::before": {
              content: '"Ações"',
              display: { xs: "block", sm: "none" },
              mb: 0.6,
              fontSize: tamanhosControlesGlobais.rotulo,
              color: "var(--sear-texto-secundario, #6983a4)",
            },
            "& td:nth-of-type(4)::before": {
              content: '"Arquivo"',
              display: { xs: "block", sm: "none" },
              mb: 0.6,
              fontSize: tamanhosControlesGlobais.rotulo,
              color: "var(--sear-texto-secundario, #6983a4)",
            },
            "@media (pointer: coarse)": {
              "& .MuiButton-root": { minHeight: 44 },
            },
          }}
        >
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <TableHead>
            <TableRow>
              {["Documento", "Status", "Ações", "Arquivo"].map((rotulo) => (
                <TableCell key={rotulo} scope="col">
                  {rotulo}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {documentosFiltrados.map(({ doc, destacado }) => {
              const { text, color } = getStatus(
                doc.alteracao_ativa,
                doc.aprovacao,
              );
              const cores =
                color === "error"
                  ? {
                      bgcolor: "var(--sear-erro-fundo, #ffeded)",
                      color: "var(--sear-erro-texto, #c34949)",
                    }
                  : color === "success"
                    ? {
                        bgcolor: "var(--sear-sucesso-fundo, #e2f4ed)",
                        color: "var(--sear-sucesso-texto, #128465)",
                      }
                    : {
                        bgcolor: "var(--sear-aviso-fundo, #fff3da)",
                        color: "var(--sear-aviso-texto, #9c6a0d)",
                      };
              return (
                <TableRow
                  key={doc.id}
                  {...ordenacao.propsLinha(doc.id)}
                  sx={{
                    cursor: podeOrdenar && !busca.trim() ? 'grab' : 'default',
                    "&:nth-of-type(even)": {
                      bgcolor: destacado
                        ? "var(--sear-superficie-azul, #eef7ff)"
                        : "var(--sear-superficie-azul, #f7fbff)",
                    },
                    "&:nth-of-type(odd)": {
                      bgcolor: destacado
                        ? "var(--sear-superficie-azul, #eef7ff)"
                        : "var(--sear-superficie, #fff)",
                    },
                    outline: destacado
                      ? "2px solid var(--sear-borda-forte, #176fb2)"
                      : undefined,
                    outlineOffset: "-2px",
                    animation:
                      destacado && !documentosVisualizados.has(String(doc.id))
                        ? `${piscarDocumento} 1.4s ease-in-out infinite`
                        : "none",
                    "@media (prefers-reduced-motion: reduce)": {
                      animation: "none",
                    },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                      <IconButton size="small" sx={{ flexShrink: 0 }} {...ordenacao.propsAlca(doc.id)}><DragIndicatorRoundedIcon sx={{ fontSize: 18 }} /></IconButton>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        {destacado && (
                          <Typography
                            component="span"
                            sx={{
                              display: "block",
                              color: "var(--sear-azul, #176fb2)",
                              fontWeight: 700,
                              fontSize: tamanhosControlesGlobais.rotulo,
                            }}
                          >
                            Documento reenviado pela escola
                          </Typography>
                        )}
                        <ButtonBase
                          onClick={() => handleVisualizarDocumento(doc)}
                          disableRipple
                          sx={{
                            display: "block",
                            width: "fit-content",
                            maxWidth: "100%",
                            userSelect: "text",
                            textAlign: "left",
                            fontSize: "inherit",
                            fontWeight: 400,
                            lineHeight: 1.4,
                            color: "inherit",
                            borderRadius: "3px",
                            overflowWrap: "anywhere",
                            "&.Mui-focusVisible": {
                              outline: "2px solid var(--sear-borda-forte, #087cf0)",
                              outlineOffset: 2,
                            },
                          }}
                        >
                          {doc.nome_documento}
                        </ButtonBase>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={text}
                      size="small"
                      sx={{
                        ...cores,
                        height: "auto",
                        py: 0,
                        borderRadius: "999px",
                        fontSize: tamanhosControlesGlobais.rotulo,
                        fontWeight: 400,
                        "& .MuiChip-label": {
                          px: "9px",
                          py: "4px",
                          lineHeight: 1.4,
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {doc.possui_historico || doc.observacao ? (
                      <Button
                        variant="text"
                        aria-label={`Consultar histórico do documento: ${doc.nome_documento}`}
                        startIcon={
                          <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 16 }} />
                        }
                        onClick={() => handleOpenHistorico(doc)}
                        sx={{
                          fontSize: tamanhosControlesGlobais.botao,
                          color: "var(--sear-azul, #0875df)",
                          textTransform: "none",
                          px: 0,
                          minWidth: 0,
                          justifyContent: "flex-start",
                          minHeight: 30,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          "&:hover": {
                            bgcolor: "transparent",
                            textDecoration: "underline",
                          },
                          "&.Mui-focusVisible": {
                            outline:
                              "2px solid var(--sear-borda-forte, #087cf0)",
                            outlineOffset: 2,
                          },
                        }}
                      >
                        Histórico
                      </Button>
                    ) : (
                      <Typography
                        component="span"
                        aria-label="Sem histórico do documento"
                        sx={{
                          fontSize: tamanhosControlesGlobais.rotulo,
                          color: "var(--sear-texto-suave, #96a7bc)",
                        }}
                      >
                        —
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      variant="text"
                      aria-label={`Visualizar: ${doc.nome_documento}`}
                      startIcon={
                        <VisibilityOutlinedIcon sx={{ fontSize: 16 }} />
                      }
                      onClick={() => handleVisualizarDocumento(doc)}
                      sx={{
                        minWidth: 0,
                        minHeight: 30,
                        p: 0,
                        textTransform: "none",
                        fontSize: tamanhosControlesGlobais.botao,
                        color: "var(--sear-azul, #0875df)",
                        bgcolor: "transparent",
                        boxShadow: "none",
                        "&:hover": {
                          bgcolor: "transparent",
                          textDecoration: "underline",
                        },
                        "&.Mui-focusVisible": {
                          outline: "2px solid var(--sear-borda-forte, #087cf0)",
                          outlineOffset: 2,
                        },
                      }}
                    >
                      Ver
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
            {documentosFiltrados.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} sx={{ textAlign: "center", py: 3 }}>
                  Nenhum documento encontrado para a pesquisa.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

        <Modal
          open={open}
          onClose={handleClose}
          disableEnforceFocus
          disableEscapeKeyDown={Boolean(acaoEmAndamento)}
        >
          <Box
            tabIndex={-1}
            sx={{
              position: "fixed",
              inset: 0,
              pointerEvents: "none",
              outline: 0,
            }}
          >
            <PapelArrastavel
              role="dialog"
              aria-labelledby="titulo-analise-documento"
              rotuloJanela="análise do documento"
              elevation={12}
              onPointerDownCapture={() => setJanelaAtiva("documento")}
              onFocusCapture={() => setJanelaAtiva("documento")}
              sx={{
                width: "min(1200px, calc(100vw - 48px))",
                height: "calc(100dvh - 48px)",
                borderRadius: "12px",
                borderTop: "4px solid var(--sear-borda-forte, #087cf0)",
                zIndex: janelaAtiva === "documento" ? 2 : 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid var(--sear-borda, #dfebf8)",
                }}
              >
                <Box
                  data-arrastar-modal
                  tabIndex={0}
                  role="button"
                  
                  aria-label="Mover análise do documento. Arraste ou use as teclas de seta."
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    px: 2.5,
                    py: 1.5,
                    cursor: "move",
                    touchAction: "none",
                    userSelect: "none",
                  }}
                >
                  <DragIndicatorRoundedIcon
                    sx={{ color: coresTextosGlobais.link }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <DialogTitle
                      id="titulo-analise-documento"
                      sx={{
                        p: 0,
                        color: coresTextosGlobais.tituloPagina,
                        fontSize: tamanhosPaginasAdministrativas.tituloSecao,
                        fontWeight: 600,
                      }}
                    >
                      Análise do documento
                    </DialogTitle>
                    <Typography
                      sx={{
                        mt: 0.5,
                        overflowWrap: "anywhere",
                        color: coresTextosGlobais.conteudoTabela,
                        fontSize: tamanhosControlesGlobais.descricao,
                      }}
                    >
                      {selectedDocument?.nome_documento}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 0.5,
                        color: coresTextosGlobais.conteudoTabela,
                        fontSize: tamanhosControlesGlobais.rotulo,
                      }}
                    >
                      Mova pelo título. Ajuste pelas bordas ou por qualquer
                      quina.
                    </Typography>
                  </Box>
                </Box>
                
                <IconButton
                  aria-label="Fechar análise do documento"
                  onClick={handleClose}
                  disabled={openDevolver || Boolean(acaoEmAndamento)}
                  sx={{ mr: 1 }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </Box>
              <DialogContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  p: 1.5,
                  bgcolor: "var(--sear-superficie-azul, #f4f8fc)",
                }}
              >
                {!openDevolver && erroAcao && (
                  <Alert severity="error" sx={{ mb: 1 }}>
                    {erroAcao}
                  </Alert>
                )}
                <Box
                  sx={{
                    display: "flex",
                    flex: 1,
                    minHeight: 0,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {loadingDocument ? (
                    <CircularProgress />
                  ) : documentError ? (
                    <Alert severity="error">{documentError}</Alert>
                  ) : documentUrl ? (
                    <iframe
                      title="Documento"
                      src={documentUrl}
                      width="100%"
                      height="100%"
                      style={{ border: "none" }}
                    />
                  ) : null}
                </Box>
              </DialogContent>
              <DialogActions
                sx={{
                  px: 2.5,
                  py: 1.5,
                  borderTop: "1px solid var(--sear-borda, #dfebf8)",
                  gap: 1,
                  "& button": {
                    textTransform: "none",
                    fontSize: tamanhosControlesGlobais.botao,
                    borderRadius: "6px",
                    boxShadow: "none",
                  },
                }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleDevolver}
                  disabled={openDevolver || Boolean(acaoEmAndamento)}
                  sx={{
                    borderColor: "var(--sear-erro-borda, #e8aeb4)",
                    bgcolor: "var(--sear-erro-fundo, #fff0f1)",
                    mr: "auto",
                    "&:hover": {
                      bgcolor: "var(--sear-erro-fundo, #ffe4e7)",
                      borderColor: "var(--sear-erro-borda, #d88c96)",
                    },
                  }}
                >
                  {selectedDocStatus.aprovacao ||
                  selectedDocStatus.alteracaoAtiva
                    ? "Correção"
                    : "Devolver"}
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleAprovar}
                  disabled={
                    openDevolver ||
                    Boolean(acaoEmAndamento) ||
                    selectedDocStatus.aprovacao ||
                    selectedDocStatus.alteracaoAtiva
                  }
                >
                  {acaoEmAndamento === "aprovar" ? "Aprovando…" : "Aprovar"}
                </Button>
              </DialogActions>
            </PapelArrastavel>

            <JanelaAuxiliar destino={janelaDevolucao.destino}>
              {openDevolver && (
                <PapelDevolucao
                  role="dialog"
                  aria-labelledby="titulo-devolucao-documento"
                  {...(!janelaDevolucao.destino && {
                    rotuloJanela: "motivo da devolução",
                  })}
                  elevation={12}
                  onPointerDownCapture={() => setJanelaAtiva("devolucao")}
                  onFocusCapture={() => setJanelaAtiva("devolucao")}
                  sx={{
                    pointerEvents: "auto",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    width: janelaDevolucao.destino
                      ? "100%"
                      : "min(640px, calc(100vw - 32px))",
                    height: janelaDevolucao.destino
                      ? "100dvh"
                      : "min(680px, calc(100dvh - 32px))",
                    borderRadius: janelaDevolucao.destino ? 0 : "12px",
                    zIndex: janelaAtiva === "devolucao" ? 2 : 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      borderBottom: "1px solid var(--sear-borda, #dfebf8)",
                      pr: 1,
                    }}
                  >
                    <Box
                      data-arrastar-modal={
                        janelaDevolucao.destino ? undefined : true
                      }
                      tabIndex={janelaDevolucao.destino ? undefined : 0}
                      role={janelaDevolucao.destino ? undefined : "button"}
                      aria-label={
                        janelaDevolucao.destino
                          ? undefined
                          : "Mover janela de devolução. Arraste ou use as teclas de seta."
                      }
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flex: "1 1 280px",
                        minWidth: 0,
                        px: 2.5,
                        py: 1.5,
                        cursor: janelaDevolucao.destino ? "auto" : "move",
                        touchAction: janelaDevolucao.destino ? "auto" : "none",
                        userSelect: "none",
                      }}
                    >
                      {!janelaDevolucao.destino && (
                        <DragIndicatorRoundedIcon
                          sx={{ color: coresTextosGlobais.link }}
                        />
                      )}
                      <Box>
                        <Typography
                          id="titulo-devolucao-documento"
                          variant="h6"
                        >
                          Motivo da devolução
                        </Typography>
                        <Typography
                          sx={{
                            color: coresTextosGlobais.conteudoTabela,
                            fontSize: tamanhosControlesGlobais.descricao,
                          }}
                        >
                          {janelaDevolucao.destino
                            ? "Para usar outro monitor, arraste a barra desta janela."
                            : "Mova pelo título. Ajuste pelas bordas ou por qualquer quina."}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      type="button"
                      variant="outlined"
                      startIcon={<OpenInNewRoundedIcon />}
                      disabled={Boolean(acaoEmAndamento)}
                      onClick={() => {
                        if (janelaDevolucao.destino) janelaDevolucao.recolher();
                        else if (janelaDevolucao.abrir()) {
                          setErroAcao("");
                        } else {
                          setErroAcao(
                            "Não foi possível abrir a janela. Permita pop-ups para o SEAR no navegador e tente novamente.",
                          );
                        }
                      }}
                      sx={{
                        mx: 1,
                        my: 1,
                        textTransform: "none",
                        fontSize: tamanhosControlesGlobais.botao,
                      }}
                    >
                      {janelaDevolucao.destino
                        ? "Voltar para a análise"
                        : "Abrir em outra janela"}
                    </Button>
                    <IconButton
                      aria-label="Fechar devolução"
                      onClick={handleCloseDevolver}
                      disabled={Boolean(acaoEmAndamento)}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  </Box>
                  <DialogContent
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {erroAcao && (
                      <Alert severity="error" sx={{ mb: 2 }}>
                        {erroAcao}
                      </Alert>
                    )}

                    <Box flexGrow={1}>
                      <Editor
                        editorState={editorState}
                        readOnly={Boolean(acaoEmAndamento)}
                        onEditorStateChange={setEditorState}
                        toolbarStyle={{
                          fontSize: ajustarTamanhoFonteAnalista("15px"),
                        }}
                        toolbar={{
                          options: ["inline", "list", "textAlign"],
                          inline: { options: ["bold", "italic", "underline"] },
                          list: { options: ["unordered", "ordered"] },
                          textAlign: {
                            options: ["left", "center", "right", "justify"],
                          },
                        }}
                        placeholder="Descreva o motivo da devolução..."
                      />
                    </Box>

                    <Box sx={{ mt: 2 }}>
                      {/*
            <Button
              variant="outlined"
              component="label"
              startIcon={<AttachFileIcon />}
            >
              Anexar arquivo
              <input
                ref={anexoInputRef}
                type="file"
                hidden
                accept=".pdf,.doc,.docx,.txt"
                onChange={handleSelecionarAnexo}
              />
            </Button>
            */}

                      {erroAnexo && (
                        <Alert severity="warning" sx={{ mt: 1 }}>
                          {erroAnexo}
                        </Alert>
                      )}

                      {anexoDevolucao && (
                        <Box
                          sx={{
                            mt: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                          }}
                        >
                          <Typography variant="body2">
                            {anexoDevolucao.name} —{" "}
                            {(anexoDevolucao.size / 1024 / 1024).toFixed(2)} MB
                          </Typography>

                          <Button
                            size="small"
                            color="error"
                            onClick={limparAnexo}
                            disabled={Boolean(acaoEmAndamento)}
                          >
                            Remover
                          </Button>
                        </Box>
                      )}
                    </Box>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSalvarDevolucao}
                      disabled={
                        Boolean(acaoEmAndamento) ||
                        !editorState
                          .getCurrentContent()
                          .getPlainText()
                          .trim() ||
                        Boolean(erroAnexo)
                      }
                      sx={{ mt: 2 }}
                    >
                      {acaoEmAndamento === "devolver"
                        ? "Devolvendo…"
                        : "Salvar e Devolver"}
                    </Button>
                  </DialogContent>
                </PapelDevolucao>
              )}
            </JanelaAuxiliar>
          </Box>
        </Modal>

      <DevolutivasDocumentoDialog
        open={openHistorico}
        documento={documentoHistorico}
        registros={historico}
        carregando={loadingHistorico}
        erro={erroHistorico}
        erroAnexo={erroAnexoHistorico}
        onClose={handleCloseHistorico}
        onRetry={() => handleOpenHistorico(documentoHistorico)}
        onBaixarAnexo={handleBaixarAnexo}
      />
    </Box>
  );
};

export default DocumentViewer;
